// extracted by mini-css-extract-plugin
export default {"behaviour":"ShowApplicationModal_behaviour__W9ReU","icon":"ShowApplicationModal_icon__3in-E"};